import { render, staticRenderFns } from "./Calendario.vue?vue&type=template&id=fb310456&scoped=true&"
import script from "./Calendario.vue?vue&type=script&lang=js&"
export * from "./Calendario.vue?vue&type=script&lang=js&"
import style0 from "./calendario.scss?vue&type=style&index=0&id=fb310456&lang=scss&scoped=true&"
import style1 from "./calendario_global.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb310456",
  null
  
)

export default component.exports